/**
 * Created by Administrator on 2017/5/2.
 */
import axios from 'axios'
import config from '../config'
import cue_config from '../config/cue_config'
import router from '../../router/index'
import Vue from 'vue'
import storage from '../../assets/tool/storage'
axios.defaults.headers.post['Content-Type'] = "application/json; charset=utf-8";
const vue = new Vue();
/**公用请求ajax的方式*/
const ajax = (path) => {
    return new Promise((resolve, reject) => {
        axios({
            url: path,
            method: 'GET',
            timeout: 10000,
        }).then((result) => {
            /**连接超时*/
            if (result.statusText === 'ERR_CONNECT_FAILED' || result.status === -1) {
                vue.$message({showClose: true, message: cue_config.OVERTIME, type: 'error'});
                return reject(cue_config.OVERTIME);
            }
            var data = result.data;
            /**没有data数据*/
            if ( !data ) {
                vue.$message({showClose: true, message: cue_config.BUSY_SERVICE, type: 'error'});
                return reject(cue_config.BUSY_SERVICE);
            }
            return resolve(data);
        }).catch ((err) => {
            vue.$message({showClose: true, message: cue_config.REQUEST_FAIL, type: 'error'});
            return reject(cue_config.REQUEST_FAIL);
        })
    })
};


export default {
    Req_FetchArticleById (article_id) {
        return ajax('./src/article/' + article_id +'.md?time_stamp=' + (new Date()).valueOf());
    },
    Req_FetchArticleList () {
        return ajax('./src/json/tree.json');
    }
}



// WEBPACK FOOTER //
// ./src/assets/api/index.js